
































































/** @format */

import { Component, Vue, Mixins } from 'vue-property-decorator';
import {
  oexceptionOrder,
  IoexceptionOrderValue,
  exportExceptionOrderExport
} from '../../../api/reconciliation-management';
import TableMixin from '@root/common/mixins/table';

import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import OrganizationSearch from '@/components/organization-search/index.vue';
import Utils from '@root/utils/common';
import { reconciliationStatusMap } from '../../../types/reconciliation-management/dictionaries';
import moment from 'moment';

@Component({
  name: 'ExceptionOrder',
  components: { ParkingLotSearch, OrganizationSearch }
})
export default class ExceptionOrder extends Mixins(TableMixin) {
  private statusList = Utils.toLabelVal(reconciliationStatusMap);
  public filterParam: any = {
    parkId: [],
    organId: [],
    chkDayStart: '',
    chkDayEnd: '',
    statusF: []
  };
  clear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList,
      organId: [],
      chkDayStart: '',
      chkDayEnd: '',
      statusF: []
    };
    this.search();
  }
  /**
   * table loading
   */
  private tableLoading: boolean = false;
  private tableData = [];

  private created() {
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkId, organId, chkDayStart, chkDayEnd, statusF } = this.filterParam;
      const { status, msg, code, data } = await oexceptionOrder({
        parkId: '' + parkId,
        organId: '' + organId,
        chkDayStart: chkDayStart,
        chkDayEnd: chkDayEnd,
        status: '' + statusF,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
        } else {
          this.tableData = [];
        }
        // this.tableData.push(total)
        // this.pageSize = this.pageSize + 1
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderEnterList  接口调用错误');
    } finally {
      this.tableLoading = false;
    }
  }

  private async download() {
    try {
      const { parkId, organId, chkDayStart, chkDayEnd, statusF } = this.filterParam;
      await exportExceptionOrderExport(
        {
          parkId: '' + parkId,
          organId: '' + organId,
          chkDayStart: chkDayStart,
          chkDayEnd: chkDayEnd,
          status: '' + statusF
        },
        '异常收入账单'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportExceptionOrderExport 异常收入账单');
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  /**
   * 日期变化
   */
  private chkDayChange(date: any, dateString: any) {
    let [chkDayStart, chkDayEnd] = dateString;
    this.filterParam.chkDayStart = chkDayStart;
    this.filterParam.chkDayEnd = chkDayEnd;
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '日期',
        dataIndex: 'chkDay',
        width: 200
      },
      {
        title: '异常订单应收',
        dataIndex: 'totalAmount',
        width: 150,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '异常订单实收',
        dataIndex: 'paidAmount',
        width: 160,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '实收交易方式',
        width: 160,
        customRender: () => {
          return '--';
        }
      },
      {
        title: '异常订单优惠',
        dataIndex: 'discountAmount',
        width: 160,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '应收未收',
        width: 150,
        dataIndex: 'unpayAmount',
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '异常订单笔数',
        width: 150,
        dataIndex: 'orderNum'
      },
      {
        title: '下账状态',
        dataIndex: 'status',
        width: 150
      }
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   fixed: 'right',
      //   width: 160,
      //   scopedSlots: { customRender: 'operation' },
      // },
    ];
  }

  toDetail() {}

  getSummaries() {}
}
